

























































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import api from '../../../api/v2/api'
import UserQuestion from '../../../api/v2/models/user_question'
import Pagination from '../../../api/v2/models/pagination'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'

@Component({
  components: { UserQuestionDialog }
})
export default class UserAnswerQuestionMyList extends Vue {
  questions: UserQuestion[] = []
  pagination: Pagination
  isLoading: boolean = true
  search = ''
  mobile = checkMobile()
  showSideBar: boolean = false

  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'アンサーした質問一覧',
      disabled: false,
      exact: true,
      to: '/classroom/my-answer-questions'
    }
  ]

  created() {
    headerState.setTitle('アンサーした質問一覧')
    this.getList()
  }

  mounted() {
    this.$root.$on('questionCreated', this.getList)
  }

  @Watch('search')
  async watchSearch(){
    this.getList()
  }

  async selectPage(page) {
    try {
      [this.pagination, this.questions] = await api.userQuestion.myQuestionAnswer({ page: page, search: this.search })
    } catch(e) {
    } finally {
    }
  }

  async getList() {
    try {
      [this.pagination, this.questions] = await api.userQuestion.myQuestionAnswer({ page: 1, search: this.search })
    } catch(e) {
    } finally {
      this.isLoading = false
    }
  }
}
